import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Container } from "react-bootstrap";

const CookiesConsentScreen = () => {
  const { t } = useTranslation();
  const [cookieChoice, setCookieChoice] = useState("");

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent") || "Não definido";
    setCookieChoice(consent);
  }, []);

  const handleConsentChange = (type) => {
    if (type !== cookieChoice) {
      localStorage.setItem("cookieConsent", type);
      setCookieChoice(type);
    }
  };

  return (
    <Container className="pb-3">
      <h3 className="py-4">{t('cookies_consent_title')}</h3>

      <section>
        <ul>
          <li className="pb-3">{t('cookies_consent_description_1')}</li>
          <li className="pb-3">{t('cookies_consent_description_2')}</li>
          <li className="pb-3">{t('cookies_consent_description_3')}</li>
          <li className="pb-3">{t('cookies_consent_description_4')}</li>
          <li className="pb-2">{t('cookies_consent_description_5')}</li>
        </ul>
      </section>

      {/*<p><strong>Opção atual de cookies:</strong> {cookieChoice}</p>*/}

      <div className="cookie-settings-container">
        <p>{t('cookies_options')}:</p>
        <button 
          onClick={() => handleConsentChange("all")} 
          className={cookieChoice === "all" ? "disabled-button" : ""}
          disabled={cookieChoice === "all"}
        >
          {t('cookies_all')}
        </button>
        <button 
          onClick={() => handleConsentChange("essential")} 
          className={cookieChoice === "essential" ? "disabled-button" : ""}
          disabled={cookieChoice === "essential"}
        >
          {t('cookies_essential')} 
        </button>
        <button 
          onClick={() => handleConsentChange("marketing")} 
          className={cookieChoice === "marketing" ? "disabled-button" : ""}
          disabled={cookieChoice === "marketing"}
        >
          {t('cookies_marketing')} 
        </button>
      </div>
    </Container>
  );
};

export default CookiesConsentScreen;
